// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// ** utils imports
import SessionStorage from '../../../utils/SessionStorage';

// initial states
const initialState = {
  questions: [],
};

export const questionsSlice = createSlice({
  name: 'questions',
  initialState,
  reducers: {},
});

export default questionsSlice.reducer;

export const { setQuestions } = questionsSlice.actions;
